import React from 'react';
import { RiUserFollowFill, RiUserUnfollowFill } from 'react-icons/ri';
import Grid from '@material-ui/core/Grid';

function LabelAcessoUsuario({ data }) {
  const { acesso, totalAtendimentos } = data;
  return (
    <Grid
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      {!!acesso ? (
        <>
          <RiUserFollowFill size={20} color={'#66BD91'} />
          <p>{totalAtendimentos}</p>
        </>
      ) : (
        <>
          <RiUserUnfollowFill size={20} color={'#F4455A'} />
          <p>{totalAtendimentos}</p>
        </>
      )}
    </Grid>
  );
}

export default LabelAcessoUsuario;
